import { useEffect } from "react";
import { useStateValue } from "../../providers";
import { useNavigate } from "react-router-dom";
import { clearActiveSave } from "../games/pinmonkey/components/character-select";

export const Logout = () => {
  const [{ session }, dispatch] = useStateValue();
  const navigate = useNavigate();

  useEffect(() => {
    clearActiveSave();
    dispatch({ type: "LOGOUT" });
  }, []);

  useEffect(() => {
    if (!session.user) navigate("/", { replace: true });
  }, [session]);

  return <>logout</>;
};
